// pairs with loadPathFromMemory on app detail page
// saves state of search and filters when user returns to search results
const { localStorage, location } = window;

export default {
  methods: {
    saveToMemory(e) {
      if (e.target.matches('.js-setPathToMemory')) {
        localStorage.setItem('lastSearch', location.href);
      }
    }
  },
  mounted() {
    window.addEventListener('click', this.saveToMemory);
  },
  destroyed() {
    window.removeEventListener('click', this.saveToMemory);
  }
};
